module.exports = __webpack_public_path__ + "img/call.7f810e7a.svg";